import cx from 'classnames';
import * as React from 'react';

import Button from 'components/Button';
import Buttons from 'components/Buttons';
import Container from 'components/Container';
import Progress from 'components/Progress';

import './styles/SequentialProgressFooter.scss';

type OptionalProps = {
  className?: string;
  nextDisabled?: boolean;
  nextButton?: React.ReactElement;
  nextButtonUrl?: string;
  onNext?: () => void;
  onPrevious?: () => void;
  previousDisabled?: boolean;
  previousButton?: React.ReactElement;
  previousButtonUrl?: string;
  progressColor?: 'lava' | 'caribbean' | 'sky' | 'brand' | 'midnight' | 'violet';
};

type DefaultProps = {
  currentStep: number;
  steps: number;
  next: boolean;
  nextButtonText: string;
  previous: boolean;
  previousButtonText: string;
  progress: boolean;
};

export type Props = OptionalProps & Partial<DefaultProps>;

export default class SequentialProgressFooter extends React.Component<
  OptionalProps & DefaultProps
> {
  static defaultProps: DefaultProps = {
    currentStep: 1,
    steps: 3,
    next: true,
    nextButtonText: 'Next',
    previous: true,
    previousButtonText: 'Back',
    progress: true,
  };

  render() {
    const previousButtonForRender = this.props.previousButton || (
      <Button
        disabled={this.props.previousDisabled}
        to={this.props.previousButtonUrl}
        color="polar-bear"
        level="secondary"
        onClick={this.props.onPrevious}>
        {this.props.previousButtonText}
      </Button>
    );

    const nextButtonForRender = this.props.nextButton || (
      <Button
        data-test-selector="next-button"
        disabled={this.props.nextDisabled}
        to={this.props.nextButtonUrl}
        onClick={this.props.onNext}>
        {this.props.nextButtonText}
      </Button>
    );

    return (
      <footer className={cx('SequentialProgressFooter', this.props.className)}>
        <Container>
          <Buttons align="right" reverseOrder="desktop---large" split reset="desktop---large">
            {this.props.previous ? previousButtonForRender : <div />}
            {this.props.next ? nextButtonForRender : <div />}
          </Buttons>
          {this.props.progress && (
            <div className="SequentialProgressFooter-progress">
              <Progress
                currentStep={this.props.currentStep}
                steps={this.props.steps}
                color={this.props.progressColor}
                size="small"
              />
            </div>
          )}
        </Container>
      </footer>
    );
  }
}
